import { useContext } from 'react';
import { App_Context } from '../context';
/**
 * 获取AppContext
 * @returns
 */
export const useAppContext = () => {
    const context = useContext(App_Context);
    return context;
};
/**
 * 获取RequestContext
 * @returns
 */
export const useRequestContext = () => {
    const context = useAppContext();
    return context === null || context === void 0 ? void 0 : context.ctx;
};
/**
 * 获取 app 上的全局状态
 * @returns
 */
export const useAppState = () => {
    const { state } = useAppContext();
    return state;
};
